// extracted by mini-css-extract-plugin
export default {"Contact":"Contact_Contact__jIZHn"};